export default __webpack_public_path__ + "static/media/intro.6f9d30e6.wav";